import { Role, RoleName } from '../../auth/models/user'
export const ROLES_DATA = [
    { id:Role.OrganizationAdmin, name: RoleName.OrganizationAdmin},
    { id:Role.User, name: RoleName.User},
    { id:Role.UserReport, name: RoleName.UserReport}
  ];